import React from 'react';

export const ForbiddenPage: React.FC = () => (
  <div className="tw-border-l-primary-900 tw-p-8">
    You don&apos;t have access to this page.
  </div>
);
